import { Grid, Stack } from "@mui/material";
import { BtnClear, BtnSearch } from "components/Button/ButtonAll";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import { MultipleSelectItem } from "components/Input/Select/MultipleSelectItem";
import moment from "moment";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { FnAxios, FnDialog } from "utilities/utilities";

//graph
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

//css
import "./FundActivityGraph.css";

//permission
import { GetMenuPermission } from "utilities/SystemFunction";

const FundActivityGraph = () => {
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const [loadingTable, setLoadingTable] = useState(false);
    const [dMinYear, setMinYear] = useState() as any;
    const [dMaxYear, setMaxYear] = useState() as any;
    const [arrActivityType, setArrActivityType] = useState([]);
    const [lstActivitySummary, setlstActivitySummary] = useState([]);
    const [lstActivityStatus, setLstActivityStatus] = useState([]);
    const [isPermission, setPermission] = useState<boolean>(false); // Permission
    const [lstUser, setUser] = useState([]);
    const form = useForm({
        shouldFocusError: true,
        mode: "all",
        defaultValues: {
            objYear: moment()
        } as any,
    });

    const getInit = () => {
        AxiosFn.Get(`FundActivityGraph/GetFilterInitial`, null, (result) => {
            setLstActivityStatus(result.objResult.lstFundWorkStatus);
            setUser(result.objResult.lstUserTypeTwo);
        });
    }

    const handleYear = (e) => {
        if ((moment(e).year() !== moment(form.getValues("objMonthStart")).year()) || moment(e).year() !== moment(form.getValues("objMonthEnd")).year()) {
            form.setValue("objMonthStart", null)
            form.setValue("objMonthEnd", null)
            form.clearErrors();
        }

        setMinYear(new Date(moment(e).year(), 0, 1));
        setMaxYear(new Date(moment(e).year(), 11, 31));
    }

    const handleClearSearch = () => {
        form.setValue("objYear", moment());
        form.setValue("objMonthStart", null);
        form.setValue("objMonthEnd", null);
        form.setValue("lstActivityStatus", []);
        form.setValue("lstUser", []);

        form.clearErrors();
    }

    const getDataForGraph = () => {
        setLoadingTable(true);
        let param = {
            nFilterYear: moment(form.getValues("objYear")).valueOf(),
            nDateStart: moment(form.getValues("objMonthStart")).valueOf(),
            nDateEnd: moment(form.getValues("objMonthEnd")).valueOf(),
            lstStatusID: form.getValues("lstActivityStatus"),
            lstUserID: form.getValues("lstUser"),
        }

        AxiosFn.Post(`FundActivityGraph/GetFundActivityData`, param, (result) => {
            setLoadingTable(false);

            setlstActivitySummary(result.lstActivityFinal);
            setArrActivityType(result.objResult.arrActivityType);
        });
    }

    const handleFundActivityGraph = () => {
        am4core.ready(function () {
            // Themes begin
            am4core.useTheme(am4themes_animated);
            // Themes end         

            // Create chart instance
            var chart = am4core.create("chartdiv", am4charts.XYChart3D);

            const arrData = lstActivitySummary.map((item) => {
                let resultData = {
                    category: item.sFName + " " + item.sLName
                    // category: item.sFullName
                };

                if (item.lstAllPlan.length > 0) {
                    item.lstAllPlan.forEach(allplan => {
                        resultData[`value_0`] = allplan.nCountWaitReportResult === 0 ? null : allplan.nCountWaitReportResult
                        resultData[`value_1`] = allplan.nCountWaitCheck === 0 ? null : allplan.nCountWaitCheck
                        resultData[`value_2`] = allplan.nCountVerified === 0 ? null : allplan.nCountVerified
                        resultData[`value_3`] = allplan.nCountUnplanWork === 0 ? null : allplan.nCountUnplanWork
                    })
                }

                return resultData;
            });

            // Add data
            chart.data = arrData;

            // Create axes
            let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
            categoryAxis.dataFields.category = "category";
            categoryAxis.renderer.grid.template.location = 0;
            categoryAxis.renderer.minGridDistance = 20;
            categoryAxis.renderer.cellStartLocation = 0.1;
            categoryAxis.renderer.cellEndLocation = 0.9;

            //label text
            let label = categoryAxis.renderer.labels.template;
            // label.wrap = true;
            label.maxWidth = 150;
            label.rotation = -45;
            label.horizontalCenter = "right";
            label.verticalCenter = "middle";
            label.truncate = true;

            let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.min = 0;
            valueAxis.title.text = "จำนวนกิจกรรม";
            valueAxis.maxPrecision = 0;

            // Create series
            function createSeries(field, name, stacked) {
                let series1 = chart.series.push(new am4charts.ColumnSeries3D());
                series1.dataFields.valueY = field;
                series1.dataFields.categoryX = "category";
                series1.name = name;
                series1.columns.template.tooltipText = "{category} {name}: [bold]{valueY}[/]";
                series1.stacked = stacked;
                series1.columns.template.width = am4core.percent(95);
                series1.columns.template.fillOpacity = .8;

                var bullet = series1.bullets.push(new am4charts.LabelBullet())
                bullet.interactionsEnabled = false
                bullet.label.text = '{valueY}'
                bullet.locationY = 0.5;
                bullet.label.fill = am4core.color('#ffffff');

                //grahp color: standard graph color
                switch (field) {
                    case 'value_0': //รอรายงานผล
                        series1.stroke = am4core.color("#DC0000").lighten(-0.5); //border color
                        series1.fill = am4core.color("#DC0000"); //inside color
                        break;
                    case 'value_1': //รอตรวจสอบ
                        series1.stroke = am4core.color("#FCE22A").lighten(-0.5); //border color
                        series1.fill = am4core.color("#FCE22A");//inside color
                        bullet.label.fill = am4core.color('#000000');
                        break;
                    case 'value_2': //ตรวจสอบแล้ว
                        series1.stroke = am4core.color("#379237").lighten(-0.5); //border color
                        series1.fill = am4core.color("#379237");//inside color                        
                        break;
                    case 'value_3': //งานนอกแผน
                        series1.stroke = am4core.color("#0081C9").lighten(-0.5); //border color
                        series1.fill = am4core.color("#0081C9");//inside color
                        break;
                }

                // //grahp color: pastel color
                // switch (field) {
                //     case 'value_0': //รอรายงานผล
                //         series1.stroke = am4core.color("#ff686b").lighten(-0.5); //border color
                //         series1.fill = am4core.color("#ff686b"); //inside color
                //         break;
                //     case 'value_1': //รอตรวจสอบ
                //         series1.stroke = am4core.color("#ffee93").lighten(-0.5); //border color
                //         series1.fill = am4core.color("#ffee93");//inside color
                //         bullet.label.fill = am4core.color('#000000');
                //         break;
                //     case 'value_2': //ตรวจสอบแล้ว
                //         series1.stroke = am4core.color("#adf7b6").lighten(-0.5); //border color
                //         series1.fill = am4core.color("#adf7b6");//inside color
                //         break;
                //     case 'value_3': //งานนอกแผน
                //         series1.stroke = am4core.color("#68b6ef").lighten(-0.5); //border color
                //         series1.fill = am4core.color("#68b6ef");//inside color
                //         break;
                // }
            }
            //console.log("item", arrActivityType);
            arrActivityType.map((item) => {
                createSeries("value_" + item.value, item.label, item.value === 3 ? false : true);
            })

            // Add legend
            chart.legend = new am4charts.Legend();

        }); // end am4core.ready()
    }

    useEffect(() => {
        let dYear = form.getValues("objYear");
        setMinYear(new Date(moment(dYear).year(), 0, 1));
        setMaxYear(new Date(moment(dYear).year(), 11, 31));
    }, [dMinYear, dMaxYear]);

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);

        if (isPermission) {
            getInit();
            getDataForGraph();
        }
    }, [isPermission]);

    useEffect(() => {
        handleFundActivityGraph();
    }, [lstActivitySummary])

    return (
        <FormProvider {...form}>
            {/* filter */}
            <Grid justifyItems={'flex-start'} justifyContent={'start'}>
                <Stack spacing={1} direction={"row"} justifyContent={'center'}>
                    <Grid item xs={12} md={12} container spacing={2} justifyItems={'flex-start'} justifyContent={'start'}>
                        <Grid item xs={12} md={1.5} justifyContent={'start'}>
                            <DatePickerItem
                                name={`objYear`}
                                id={`objYear`}
                                label={"ปี"}
                                IsYearPicker
                                required={true}
                                onChange={(e) => { handleYear(e) }}
                            />
                        </Grid>
                        <Grid item xs={12} md={2} justifyContent={'start'}>
                            <DatePickerItem
                                name={`objMonthStart`}
                                id={`objMonthStart`}
                                label={"ตั้งแต่วันที่"}
                                view={["month", "day"]}
                                minDate={dMinYear}
                                maxDate={dMaxYear}
                                required={false}
                                defaultCalendarMonth={moment().startOf('year').year(moment(form.getValues("objYear")).year())}
                            />
                        </Grid>
                        <Grid item xs={12} md={2} justifyContent={'start'}>
                            <DatePickerItem
                                name={`objMonthEnd`}
                                id={`objMonthEnd`}
                                label={"ถึงวันที่"}
                                view={["month", "day"]}
                                minDate={dMinYear}
                                maxDate={dMaxYear}
                                required={false}
                                defaultCalendarMonth={moment().startOf('year').year(moment(form.getValues("objYear")).year())}
                            />
                        </Grid>
                        <Grid item xs={12} md={3} justifyContent={'start'}>
                            <MultipleSelectItem
                                id={"lstActivityStatus"}
                                name={"lstActivityStatus"}
                                label={"สถานะ"}
                                required={false}
                                options={lstActivityStatus}
                                limitTag={1}
                            />
                        </Grid>
                        <Grid item xs={12} md={3.5} justifyContent={'start'}>
                            <MultipleSelectItem
                                id={"lstUser"}
                                name={"lstUser"}
                                label={"พนักงาน"}
                                required={false}
                                options={lstUser}
                                limitTag={1}
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </Grid>

            <Grid container xs={12} md={12} spacing={1} sx={{ mt: "2%" }} justifyContent={'center'}>
                <Grid item>
                    <BtnSearch id={'btnSearchAll'} IsCircleWithOutText={false} onClick={form.handleSubmit(() => getDataForGraph())} />
                </Grid>
                <Grid item>
                    <BtnClear id={'btnClearSearchAll'} IsCircleWithOutText={false} onClick={() => { handleClearSearch(); getDataForGraph(); }} />
                </Grid>
            </Grid>
            {/* endfilter */}

            {/* graph data */}
            <Grid sx={{ mt: "4%" }}>
                {/* <div id="chartdiv"></div> */}
                <div id="chartdiv" style={{ width: "100%", height: "550px" }}></div>
            </Grid>
            {/* end graph data */}
        </FormProvider>
    );
}

export default FundActivityGraph;